import { createApp } from "vue";
import AppLayout from "./layout/index.vue";
import router from "./router";
import store from "./store";
import { registerScrollSpy } from "vue3-scroll-spy";
import VueScrollTo from "vue-scrollto";
import Vue3Sanitize from "vue-3-sanitize";
import print from "vue3-print-nb";
import vueVimeoPlayer from "vue-vimeo-player";

import BootstrapVue3 from 'bootstrap-vue-3';

// Botstrap styles
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

const app = createApp(AppLayout);
app.config.devtools = true
registerScrollSpy(app);
app.use(store);
app.use(router);
app.use(Vue3Sanitize);
app.use(vueVimeoPlayer);
app.use(BootstrapVue3);
app.use(print);
app.use(VueScrollTo, {
  container: "body",
  easing: "ease",
  offset: -store.getters["dom/topMenuOffset"],
  duration: 1000,
  force: true,
  cancelable: true,
  x: false,
  y: true,
});

// new Vue({
//     router,
//     store,
//     render: h => h(App)
// }).$mount('#app');

router.isReady().then(() => {
  app.mount("#app");
  store.dispatch(
    "purl/setPurlId",
    router.currentRoute.value.params.purlId || "purlId not included"
  );
  store.commit("dom/SET_WINDOW_WIDTH", window.innerWidth);
  window.addEventListener("resize", () =>
    store.commit("dom/SET_WINDOW_WIDTH", window.innerWidth)
  );
  document.documentElement.className = store.getters["dom/getTheme"];
});

// Bootstrap JS
// import "bootstrap/dist/js/bootstrap.js";
